module.exports = __webpack_public_path__ + "bb1.no1.a89fe26f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bb1.no1.jpg
// module id = UR9E
// module chunks = 0